import dispatcher from '../dispatcher';
import colorStore from '../color/color.store';

var elementProto = Object.create(HTMLElement.prototype);

elementProto.createdCallback = function() {
}
elementProto.attachedCallback = function() {
	var color = this.getAttribute('data-color');

	dispatcher.dispatch({
		type: 'color:set-default',
		color: color
	});
	dispatcher.dispatch({
		type: 'color:change',
		color: color
	});
}
elementProto.detachedCallback = function() {
}

document.registerElement('color-helper', {
	prototype: elementProto
});